
    import './styles.scoped.css';
    export default {
  "notifications": "awsui_notifications_1hmm4_1lppl_9",
  "notifications-sticky": "awsui_notifications-sticky_1hmm4_1lppl_10",
  "no-content-paddings": "awsui_no-content-paddings_1hmm4_1lppl_25"
};
  